import React from 'react';
export function AntdIconWrapper({ children }: { children: React.ReactNode }) {
  return (
    <span role="img" aria-label="arrow-left" className="anticon ">
      {children}
    </span>
  );
}
